import React, { useEffect } from "react";
import Header from "../components/Header";
import "./css/DesignClubOnboarding.css";
import Footer from "../components/Footer";

export default function DesignClubOnboarding() {

	useEffect(() => {

	}, []);



	return (
		<>
			<div className="App">
				<Header />
			</div>

			<section className="dc_onboarding_form">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div className="onboarding_form">
								
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>

	);


}
